import store from "@/store";
// custom mapActions

function openModal(options: any) {
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // description: opens a modal (the component is '@/components/CustomModal.vue', included in @/components/layout/Page.vue) //
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  store.dispatch("modal/openModal", options);
}

function setModalLoading(flag: boolean) {
  store.dispatch("modal/setModalLoading", flag);
}

function closeModal() {
  /////////////////////////////////
  // description: closes a modal //
  /////////////////////////////////
  store.dispatch("modal/closeModal");
}

// export the following functions
export default Object.assign(
  {},
  {
    openModal,
    setModalLoading,
    closeModal,
  },
);
